import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import AuthorizationAPI from '../services/AuthorizationAPI';
import Alert from '../Alert/Alert';
import styles from './SidePanel.module.scss';

export interface SidePanelProps {
  links?: AuthorizedProduct[],
}

export interface AuthorizedProduct {
  idtProduct: number | string,
  name: string,
  url: string
}

const SidePanel: React.FC<SidePanelProps> = ({ links }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [productsLinks, setProductsLinks] = useState(links);
  const homeLink: AuthorizedProduct = {
    idtProduct: 'home', name: 'Página Inicial', url: null,
  };
  const devLink: AuthorizedProduct = {
    idtProduct: 'dev', name: 'Desenvolvedor', url: null,
  };

  useEffect(() => {
    if (!productsLinks.length) {
      setIsLoading(true);
      setHasError(false);
      fetchAllAuthorizedProducts();
    }
  }, []);

  const fetchAllAuthorizedProducts = async () => {
    try {
      setIsLoading(true);
      setHasError(false);
      const authorizedProducts = await AuthorizationAPI.getAuthorizedProducts();
      setProductsLinks(authorizedProducts);
    } catch (e) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleMenu = () => {
    setIsVisible(!isVisible);
  };

  const resetLinks = () => {
    fetchAllAuthorizedProducts();
  };

  const navLinkHandler = () => {
    setIsVisible(false);
  };

  const renderLinks = (products: AuthorizedProduct[]) => products.map((p) => (
    <li key={p.idtProduct}>
      <NavLink
        to={{ pathname: `/produto/${p.idtProduct}` }}
        onClick={navLinkHandler}
      >
        <span className={`icon-uolhost icon-uolhost-${p.idtProduct}`} />
        {p.name}
      </NavLink>
    </li>
  ));

  return (
    <aside className={styles.sidePanel}>
      <button className={styles.hamburguer} type="button" onClick={toggleMenu}>
        <span className="glyphicon glyphicon-align-justify" />
        Menu de produtos
      </button>

      <div className={`${!isVisible ? styles.hidden : null}`}>
        <ul>
          {renderLinks([homeLink])}

          <li hidden={!isLoading}>
            <Alert variant="loading" size="xs" hasBackground>
              <strong>Carregando</strong>
            </Alert>
          </li>

          <li hidden={!hasError} className={styles.ErrorMessage}>
            <Alert variant="danger" size="xs" hasBackground onClick={resetLinks}>
              <strong>Recarregar listagem</strong>
            </Alert>
          </li>

          {renderLinks(productsLinks)}
        </ul>

        <ul className={styles.underLinks}>
          {renderLinks([devLink])}
        </ul>
      </div>
    </aside>
  );
};

SidePanel.defaultProps = {
  links: [],
};

export default SidePanel;
